import {
  REQUEST_ZOGENIX_SPAIN_SEARCH,
  RESPONSE_ZOGENIX_SPAIN_SEARCH,
  FAILURE_ZOGENIX_SPAIN_SEARCH,
  UPDATE_ZOGENIX_SPAIN_COLUMN_STATES
} from '../../../actions/types';

import { localColumnWeights, localTotalWeights } from "../../../_components/Application/SocialMedia/Spain/constants"

const initialState = {
  isFetching: false,
  error: false,
  results: [],
  total: 0,
  filters: {
    speciality: [],
    twitterHandle: false,
    entityType: "individual",
    traditionalKol: false,
    size: 25,
    activePage: 1,
    from: 0,
    queryText: "",
    selectedKey: "DS",
    experts: [],
    sort: {
      name: "Total_band",
      order: "desc",
    },
    defaultColumnWeights: { ...localColumnWeights },
    defaultTotalWeights: { ...localTotalWeights },
  },
};

const setRequest = (state, action) => {
  let { filters = {} } = action.payload;
  filters = filters || {};
  let { entityType, from, size, activePage, sort, columnsWeights: defaultColumnWeights, totalWeights: defaultTotalWeights } = filters || {};
  return {
    ...state,
    isFetching: true,
    error: false,
    results: [],
    total: 0,
    filters: {
      ...filters,
      entityType,
      from,
      size,
      activePage,
      sort,
      defaultColumnWeights,
      defaultTotalWeights,
    },
  };
};

const setResponse = (state, action) => {
  let { results = [], total = 0 } = action.payload;
  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    total,
  }
}

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    total: 0
  }
}

const updateColumnState = (state, action) =>{
  let payload = action.payload || {};
  return {
    ...state,
    updatedCols: payload.updatedCols
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ZOGENIX_SPAIN_SEARCH:
      return setRequest(state, action);

    case RESPONSE_ZOGENIX_SPAIN_SEARCH:
      return setResponse(state, action);

    case FAILURE_ZOGENIX_SPAIN_SEARCH:
      return setFailure(state, action);
    
    case UPDATE_ZOGENIX_SPAIN_COLUMN_STATES:
      return updateColumnState(state, action);

    default:
      return state
  }
}